import { Children } from "react";
export var buildSlots = function buildSlots() {
  var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var allowedSlots = arguments.length > 1 ? arguments[1] : undefined;
  var childrenArray = Children.toArray(children);
  var availableSlots = {};
  childrenArray.forEach(function (child) {
    var _child$type;
    var potentialSlot = child === null || child === void 0 ? void 0 : (_child$type = child.type) === null || _child$type === void 0 ? void 0 : _child$type.slotName;
    if (potentialSlot && allowedSlots.includes(potentialSlot)) {
      availableSlots["".concat(potentialSlot, "Slot")] = child;
    }
  });
  return availableSlots;
};